export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL;
export const GRAPHQL_USER = process.env.REACT_APP_GRAPHQL_USER;
export const GRAPHQL_PASS = process.env.REACT_APP_GRAPHQL_PASS;